module.exports = __webpack_public_path__ + "static/img/20240104-163100.476c94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20240104-163100.png
// module id = 5aLv
// module chunks = 12